import type { PlanRow } from '../row';
import type { PlanStore } from './state/plan';
import type { BudgetGroup, PlanFactor } from './types';

// @TODO fix types, response entites have ids, request upster for new has no ids
// for budget groups and factors we awlays end full object?
// i guess optonal collections and keys should also be fine for responses?

export function applyEntityDiffToRecord<T extends Entity>(
  current: Record<number, T>,
  diff: EntityDiff<T>,
): Record<number, T> {
  if (!diff.upsert?.length && !diff.remove?.length) {
    return current;
  }

  const next = { ...current };

  for (const id of diff.remove ?? []) {
    delete next[id];
  }

  for (const item of diff.upsert ?? []) {
    next[item.id] = item;
  }

  return next;
}

export interface Entity {
  id: number;
  [key: string]: any;
}

export interface EntityDiff<T> {
  upsert?: T[];
  remove?: number[];
}

export interface PlanDiffResponse {
  rows?: EntityDiff<PlanRow>;
  groups?: EntityDiff<BudgetGroup>;
  factors?: EntityDiff<PlanFactor>;
}

type Patch<T> = Partial<T>;

// `_reset` replaces dependent values instead of preserving them (e.g. supplier change).
export type RowPatch = Patch<PlanRow> & { _reset?: boolean };

// Clipboard patch for an existing group — the group update endpoint expects
// the full object, so group paste yields a complete `BudgetGroup` (built from
// the current row), not a partial. Creation (no id) goes through other paths.
export type GroupPatch = BudgetGroup;

export interface PlanDiffRequest {
  // We use Partial<EntityDiff> so you can send just 'upsert', just 'remove', or both.
  rows?: Partial<EntityDiff<RowPatch>>;
  groups?: Partial<EntityDiff<Patch<BudgetGroup>>>;
  factors?: Partial<EntityDiff<Patch<PlanFactor>>>;
}

export function applyPlanDiff(store: PlanStore, diff: PlanDiffResponse): PlanStore {
  return {
    ...store,
    rows: diff.rows ? applyEntityDiffToRecord(store.rows, diff.rows) : store.rows,
    groups: diff.groups ? applyEntityDiffToRecord(store.groups, diff.groups) : store.groups,
    factors: diff.factors ? applyEntityDiffToRecord(store.factors, diff.factors) : store.factors,
  };
}
